import MyAccountLoginTrigger from "@routes/MyAccount/components/MyAccountLoginTrigger";
import { MyAccountEmptyStateReadConstants } from "@routes/MyAccount/utils/constants";

/**
 * MyAccountReadingHistoryPopoverLoginState is a component displayed in my account reading history popover when the user is not logged in.
 * Figma: https://www.figma.com/design/soi1ZhMqZHbss6tJLvLgaa/MY-ACCOUNT--WEB-?node-id=3623-20694&t=XsTPoO6b0V5zVeJ1-4
 */
const MyAccountReadingHistoryPopoverLoginState = (): React.ReactElement => {
  return (
    <div
      data-testid="my-account-reading-history-login-state-component"
      className="w-[360px] p-6 text-center"
    >
      <div
        data-testid="my-account-reading-history-popover-empty-state-component"
        className="text-center"
      >
        <img
          src={MyAccountEmptyStateReadConstants.src}
          alt="my account myBT"
          width={180}
          height={170}
          className="mx-auto mb-8 mt-10"
        />

        <div className="mb-4">
          <p className="mb-0 font-poppins font-bold text-gray-850">
            {MyAccountEmptyStateReadConstants.title}
          </p>
          <p className="font-xs mb-0 font-poppins text-gray-850">
            {MyAccountEmptyStateReadConstants.description}
          </p>
        </div>

        <MyAccountLoginTrigger className="mx-auto rounded-[50px] border border-gray-175 bg-none px-10 py-4 lg:hover:bg-transparent" />
      </div>
    </div>
  );
};

export default MyAccountReadingHistoryPopoverLoginState;
